<template>
  <div class="video-crawler-settings-toggle-container">
    <div class="video-crawler-settings-toggle">
      <h5>Enable Video Crawler</h5>
      <label>เปิดหรือปิดการใช้งาน Crawler การปิด Crawler จะทำให้ข้อมูลของวิดีโอไม่ถูกดึงมาแสดง การเปิด Crawler จะทำการดึงข้อมูลวิดีโอมาแสดง รวมทั้งแทนที่ข้อมูลวิดีโอก่อนหน้านี้</label>
      <div class="config-container-warning" v-if="!state.isLoading && !shouldShowCrawlerConfig">
        <span class="text-danger">*** ไม่สามารถปรับตั้งค่า Crawler ของโปรเจคท์นี้ได้ กรุณาติดต่อทีมงาน ByteArk ***</span>
      </div>
      <div class="video-crawler-settings-toggle__switch" v-if="shouldShowCrawlerConfig">
        <div class="switch-container mt-2">
          <i class="switch-icon fa fa-toggle-on text-primary" v-if="!crawler.isDisabled" @click="onClickToggleSwitch" />
          <i class="switch-icon fa fa-toggle-off" v-if="crawler.isDisabled" @click="onClickToggleSwitch" />
          <div class="switch-text pl-2" @click="onClickToggleSwitch">{{ crawler.isDisabled ? 'ปิดใช้งาน Crawler' : 'เปิดใช้งาน Crawler' }}</div>
        </div>
      </div>
      <FormFooter class="mt-4" v-if="shouldShowCrawlerConfig">
        <Button @click="onSaveCrawlerSettings">
          <span>{{ state.isLoading ? '' : 'Save' }}</span>
          <span class="spinner-border spinner-border-sm" role="status" v-if="state.isLoading" />
        </Button>
        <span class="pl-2 text-success" v-if="state.isSaved"><i class="fa fa-check" /></span>
      </FormFooter>
    </div>
  </div>
</template>

<script>
import { editCrawlerSettings } from '@/project/api/';

import Button from '@/form/Button.vue';
import FormFooter from '@/form/FormFooter.vue';

export default {
  props: ['project', 'initialCrawler'],
  components: {
    Button,
    FormFooter,
  },
  data() {
    return {
      state: {
        isLoading: false,
        isSaved: false,
        enableCrawler: false,
      },
      crawler: {},
    };
  },
  computed: {
    shouldShowCrawlerConfig() {
      return this.project.enabledCrawlerConfiguration;
    },
  },
  created() {
    this.crawler = this.initialCrawler;
  },
  methods: {
    onClickToggleSwitch() {
      this.crawler.isDisabled = !this.crawler.isDisabled;
    },
    async onSaveCrawlerSettings() {
      this.state.isLoading = true;
      this.state.isSaved = false;
      const response = await editCrawlerSettings(this.project.projectId, this.crawler);
      this.crawler = response.data.crawler;
      this.state.isLoading = false;
      this.state.isSaved = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.switch-container {
  display: flex;
  align-items: center;
}

.switch-icon {
  font-size: 24px;
  cursor: pointer;
  user-select: none;
}
.switch-text {
  cursor: pointer;
  user-select: none;
}
</style>
